<template>
  <!-- <pre v-if="responseData"> testData={{ responseData }}</pre> -->
  <AdminBackground v-if="responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/PERJAWATAN.png"
        alt="PERJAWATAN"
        class="pbt-image"
      >
      <div class="line-under-image" />
    </div>

    <div class="content-wrapper">
      <AppAutocomplete
        v-model="selectedYear"
        label="Tahun"
        :items="years"
        placeholder="Pilih Tahun"
        chips
        class="app-date-picker"
      />

      <h2>Perjawatan JKT</h2>

      <div class="chart-wrapper">
        <h2>Bilangan Pengisian dan Kekosongan Mengikut Kategori</h2>
        <DoubleBar 
          :chart-data="PengisianData"
          :chart-categories="PengisianNames"
          :legend-labels="['Pengisian', 'Kekosongan']"
          :series-colors="['#0000FF ','#029708']"
        />
      </div>

      <div class="tables-row">
        <!-- Perjawatan Table -->
        <div class="table-container small">
          <table class="status-table">
            <thead>
              <tr>
                <th colspan="2">
                  Perjawatan
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="total-row">
                <td colspan="2">
                  {{ totalPerjawatan }}
                </td>
              </tr>
              <tr>
                <th>HQ</th>
                <th>OSC</th>
              </tr>
              <tr>
                <td>{{ perjawatan?.HQ || 0 }}</td>
                <td>{{ perjawatan?.OSC || 0 }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pengisian Table -->
        <div class="table-container small">
          <table class="status-table">
            <thead>
              <tr>
                <th colspan="2">
                  Pengisian
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="total-row">
                <td colspan="2">
                  {{ totalPengisian }}
                </td>
              </tr>
              <tr>
                <th>HQ</th>
                <th>OSC</th>
              </tr>
              <tr>
                <td>{{ pengisianTotal?.HQ || 0 }}</td>
                <td>{{ pengisianTotal?.OSC || 0 }}</td>
              </tr>
            </tbody>
          </table>
        </div>


        <!-- Kekosongan Table -->
        <div class="table-container small">
          <table class="status-table">
            <thead>
              <tr>
                <th colspan="2">
                  Kekosongan
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="total-row">
                <td colspan="2">
                  {{ totalKekosongan }}
                </td>
              </tr>
              <tr>
                <th>HQ</th>
                <th>OSC</th>
              </tr>
              <tr>
                <td>{{ kekosonganTotal?.HQ || 0 }}</td>
                <td>{{ kekosonganTotal?.OSC || 0 }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>  

      <!-- No data in eProfil -->
      <div class="table-container">
        <h2>Kekosongan (OSC)</h2>
        <table class="status-table">
          <thead>
            <tr>
              <th>Jawatan</th>
              <th>Gred</th>
              <th>Penempatan</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>0</td>
              <td>0</td>
              <td>0</td>
            </tr>
          </tbody>
        </table>
      </div>   
    </div>
    <PrimaryModule />
    <KhidmatPengurusan />
  </AdminBackground>
</template>

<script setup>
import KhidmatPengurusan from '@/components/menu-items/section-menu/khidmat-pengurusan-menu.vue'
import { useHttpService } from "@/httpService"
import { onMounted, ref } from 'vue'

definePage({
  alias: '/pages/pages/inspektorat/i-tegur',
  meta: {
    layout: 'blank',
    public: true,
  },
})

const { httpGet, numberWithCommas } = useHttpService()

const responseData = ref(null)

const years = ref([2022, 2023, 2024, 2025, 2026])
const selectedYear = ref(2026)

const staffTotal = ref(0)
const fillValue = ref(0)
const emptyValue = ref(0)
const perjawatan = ref({ HQ: 0, OSC: 0 }) 
const pengisianTotal = ref({ HQ: 0, OSC: 0 })
const kekosonganTotal = ref({ HQ: 0, OSC: 0 })
const PengisianData = ref([])
const PengisianNames = ref([])

const totalPerjawatan = computed(() => staffTotal.value)
const totalPengisian = computed(() => fillValue.value)
const totalKekosongan = computed(() => emptyValue.value)

async function loadDataFromApi(year) {
  try {
    const response = await fetch(`https://ejkt.kpkt.gov.my/eprofil/api/gate/management_staffs?year=${year}`)
    const apiResponse = await response.json()

    responseData.value = apiResponse.data?.data || []

  
    if (responseData.value.length > 0) {
      const data = responseData.value[0]
 
      staffTotal.value = data.staff_total || 0
      fillValue.value = data.fill_value || 0
      emptyValue.value = data.empty_value || 0

      perjawatan.value = {
        HQ: data.staff_hq || 0,
        OSC: data.staff_osc || 0,
      }

      pengisianTotal.value = {
        HQ: data.fill_hq || 0,
        OSC: data.fill_osc || 0,
      }

      kekosonganTotal.value = {
        HQ: data.empty_hq || 0,
        OSC: data.empty_osc || 0,
      }
    }

    PengisianNames.value = [
      "Pengurusan dan Profesional (OSC)",
      "Pengurusan Tertinggi",
      "Sokongan 1",
      "Sokongan 2",
    ]

    PengisianData.value = [

      [
        responseData.value[0]?.fill_osc || 0, 
        responseData.value[0]?.staff_hq || 0,
        responseData.value[0]?.fill_hq || 0, 
        responseData.value[0]?.staff_hq || 0, 
      ],
      [
        responseData.value[0]?.empty_osc || 0,
        responseData.value[0]?.empty_hq || 0,
        responseData.value[0]?.empty_hq || 0, 
        responseData.value[0]?.staff_osc || 0,  
      ],
    ]

  } catch (err) {
    console.error('loadDataFromApi failed:', err)
  }
}


watch(selectedYear, newYear => {
  loadDataFromApi(newYear) 
})

onMounted(() => {
  loadDataFromApi(selectedYear.value)
})
</script>


<style scoped>
.close-button {
  color: black; 
  background-color: transparent; 
  border: none;
  font-size: 16px; 
  cursor: pointer;
  margin-top: 20px;
}

.close-button:hover {
  text-decoration: underline; 
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 10px;
  max-width: 500px;
  width: 100%;
}

.modal-content h3 {
  margin-bottom: 10px;
  color: rgb(0, 0, 0);
  font-size: 1.5rem;
  font-weight: bold;
}


.tables-row {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.table-container {
  
  width: 100%;
}

.table-container.small {
  flex: 1;
  max-width: 30%; /* Adjust as needed to control table width */
}

.status-table {
  width: 100%;
  border-collapse: collapse;
  background-color: white;
  text-align: center;
}

.total-row {
  background-color: white;
  font-weight: bold;
  text-align: center;
}

.status-table th {
  background-color: #f2f2f2;
  font-weight: bold;
  color: #333;
}

.status-table td {
  color: #000;
  padding: 12px;
}

.status-table th,
.status-table td {
  border: 1px solid #ddd;
  padding: 12px;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.chart-wrapper {
  padding: 20px;
  border-radius: 10px;
  background: rgba(255, 254, 254, 80%);
  inline-size: 100%;
  max-inline-size: 1400px;
  margin-top: 10px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%;
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%;
  margin-block-start: 10px;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%);
  border-radius: 20px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
  margin: 10px 0;
}

h2 {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  font-weight: bold;
  inline-size: 100%;
  margin-block: 10px 10px;
  text-align: left;
  text-transform: uppercase;
}

.table-container {
  margin-top: 20px;
}

.clickable-cell {
  cursor: pointer; 
  color: inherit;  
}

.clickable-number {
  color: blue; 
  text-decoration: underline; 
}

.clickable-cell:hover .clickable-number {
  text-decoration: none; 
}


@media (max-width: 768px) {
  .table-container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .status-table {
    min-width: 800px;
  }

  h2 {
    font-size: 1.2rem;
  }

  .modal-content {
    padding: 15px; 
  }
}

@media (max-width: 480px) {
  .tables-row {
    flex-direction: column; 
  }

  .status-table {
    min-width: 600px;
  }

  h2 {
    font-size: 1rem;
  }

  .modal-content {
    padding: 10px; 
  }

  .clickable-number {
    font-size: 14px;
  }
}
</style>
